import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, Inject, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FirstTimeModalComponent } from 'src/app/shared/components/first-time-modal/first-time-modal.component';
import { filter } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
declare var window:any;
import * as bootstrap from 'bootstrap';
import { PdfSummaryService } from '../../service/pdf-summary.service';
import { ToastrService } from 'ngx-toastr';
import { OktaAuthService } from '../../okta/okta.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({
        display: 'block',
        opacity: 1,
      })),
      state('out', style({
        display: 'none',
        opacity: 0,
      })),
      transition('in => out', animate('400ms ease-out')),
      transition('out => in', animate('400ms ease-in')),
    ]),
  ],
})
export class HeaderComponent {
  isChecked = false;
  activeButtonActive: boolean = false;
  activeSubmenu: any = null; // Initialize to null to hide all submenus by default
  activeSubchild:any;
  showModal = false;
  selectedFilesPrompt: File[] = [];
  logFileList = [];
  viewType = '';
  menuSidebar:any = [
    {
      link_name: 'Language Translation',
      parent: 'translation',
      link: '/docsummary/translate',
      icon: 'fa fa-language',
      img: '',
      // children: [
      //   {
      //     link_name: 'About',
      //     link: '/about',
      //     parent: 'about',
      //     icon: 'fa fa-info-circle imgi2',
      //     active: false
      //   }
      // ],
      isCollapsed: false,
      active: false
    },
    {
      link_name: 'Summary',
      // link: document-summary,
      link: '/docsummary/document-summary',
      icon: 'fa fa-file-text-o imgi2',
      parent: 'summary',
      showSubMenu: false,
      isCollapsed: false,
      active: false,
      // children: [],
      // children: [
      //   {
      //     link_name: 'Demo',
      //     link: '/document-summary',
      //     parentClass: 'summary',
      //     active: false
      //   },

      // ],
    },
    // {
    //   link_name: 'About',
    //   link: '/about',
    //   parent: 'about',
    //   icon: 'fa fa-info-circle imgi2',
    //   children: [],
    // },
    {
      link_name: 'Contact',
      link: '/docsummary/contact',
      parent: 'contact',
      icon: 'fa fa-envelope-o imgi2',
      children: null,
    },
  ];
  formModal:any;
  @ViewChild('testModal')
  testModal!: ElementRef;
  dropdownType: string = "Select";
  @Input() access : any;
  viewTypeRole = ''
  @ViewChild('fileInputPrompt') fileInputPrompt!: ElementRef;
  @Input() docType : any;

    constructor(public dialog: MatDialog,
    public router: Router,@Inject(DOCUMENT) private document: Document,
    public pdfSummaryService: PdfSummaryService,
    private toastr: ToastrService, private oktaService:OktaAuthService){

      this.router.events.pipe(
        filter((event:any) => event instanceof NavigationEnd)
      ).subscribe((event:any) => {
        console.log(event);

    });
    this.handleRouteChange( window.location.pathname)
    }
    ngOnChanges(changes: SimpleChanges) {
      
      this.access = changes?.['access']?.currentValue;
      this.docType = changes?.['docType']?.currentValue;

      console.log(this.access);
      if(this.access){
        this.formModal?.show();
      }
      console.log(changes);
      
    }
    
ngOnInit(){  
  // const tokenData = {"idToken":{"idToken":"eyJraWQiOiI4bDRaYTVGZzlTaVJyd3FiZTlkTGdia1VOUDFqZ09vdlZHNEd5M3R3SllrIiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIwMHU3YWhocGU3OXozOGtKeDB4NyIsIm5hbWUiOiJDaGF1aGFuLCBIZW1hIiwiZW1haWwiOiJIZW1hLkNoYXVoYW5AZ2VucGFjdC5jb20iLCJ2ZXIiOjEsImlzcyI6Imh0dHBzOi8vZ2VucGFjdC5va3RhcHJldmlldy5jb20vb2F1dGgyL2RlZmF1bHQiLCJhdWQiOiIwb2E2YWt5eGVyYjVDcVFHYzB4NyIsImlhdCI6MTcxMzk0NDIxOCwiZXhwIjoxNzEzOTQ3ODE4LCJqdGkiOiJJRC5HTDBjRTlsNmJ2bHRraVh3cUp2cVluT3hBY2JvdlFVdmRRSHprbHpPdV9rIiwiYW1yIjpbInN3ayIsIm1mYSIsInB3ZCJdLCJpZHAiOiIwMG81a2gzOHJzNkZWZW5ZUzB4NSIsIm5vbmNlIjoiUDV0anM0TzdhSENlZ2E2MEVDc2pncjhqRFpEM1pFNlpJODFDYzljRXQ0MUdrRVdFejRmR09LUzVaNkxydGxVZyIsInByZWZlcnJlZF91c2VybmFtZSI6Ijg1MDA3MDgxOUBnZW5wYWN0LmNvbSIsImF1dGhfdGltZSI6MTcxMzkzNjY5NywiYXRfaGFzaCI6Il9nNGlDSTh5eVk3Q2tPV2FJeFRjakEiLCJtYWlsIjoiSGVtYS5DaGF1aGFuQGdlbnBhY3QuY29tIn0.FPTROErBtbeoC8S-uoJb3aPnoXxKZj4PUF99E4qE-kKxy1oV_-q0Z9RipqGhL8x4mUdBB8eqT1YxFPBELCkfjhLLmD-BpyQfb3mUiW4BGJYWRYI0rq6qjga1WQ3e0EVq7L8H4e2mYZ6PLV3u0DfF7itPQij07myXf23ZDCjKwECP6ESN5gR2RnqToYfkWecIyMU7zM1TZ7UhYXf8qqt71-KxA8CunjMvCSe6nCNDcCrhuZhvu6oT955yj2mN0iqWpStt4fyKndRrXDiJv4Ten5zyZ8WoiXJu4K3C4yCWx4USc9nKR8gZXrgzFwD_HCVFSMMeyYwh_0Ew-Igyn1BQTA","claims":{"sub":"00u7ahhpe79z38kJx0x7","name":"Chauhan, Hema","email":"Hema.Chauhan@genpact.com","ver":1,"iss":"https://genpact.oktapreview.com/oauth2/default","aud":"0oa6akyxerb5CqQGc0x7","iat":1713944218,"exp":1713947818,"jti":"ID.GL0cE9l6bvltkiXwqJvqYnOxAcbovQUvdQHzklzOu_k","amr":["swk","mfa","pwd"],"idp":"00o5kh38rs6FVenYS0x5","nonce":"P5tjs4O7aHCega60ECsjgr8jDZD3ZE6ZI81Cc9cEt41GkEWEz4fGOKS5Z6LrtlUg","preferred_username":"850070819@genpact.com","auth_time":1713936697,"at_hash":"_g4iCI8yyY7CkOWaIxTcjA","mail":"Hema.Chauhan@genpact.com"},"expiresAt":1713947819,"scopes":["openid","profile","email"],"authorizeUrl":"https://genpact.oktapreview.com/oauth2/default/v1/authorize","issuer":"https://genpact.oktapreview.com/oauth2/default","clientId":"0oa6akyxerb5CqQGc0x7"},"accessToken":{"accessToken":"eyJraWQiOiI4bDRaYTVGZzlTaVJyd3FiZTlkTGdia1VOUDFqZ09vdlZHNEd5M3R3SllrIiwiYWxnIjoiUlMyNTYifQ.eyJ2ZXIiOjEsImp0aSI6IkFULnNZUEViR09tZDJXeXhjdXNQcXc5SXljUzZWd2FPa1ZNQWowTUh0LTY3LU0iLCJpc3MiOiJodHRwczovL2dlbnBhY3Qub2t0YXByZXZpZXcuY29tL29hdXRoMi9kZWZhdWx0IiwiYXVkIjoiYXBpOi8vZGVmYXVsdCIsImlhdCI6MTcxMzk0NDIxOCwiZXhwIjoxNzEzOTQ3ODE4LCJjaWQiOiIwb2E2YWt5eGVyYjVDcVFHYzB4NyIsInVpZCI6IjAwdTdhaGhwZTc5ejM4a0p4MHg3Iiwic2NwIjpbIm9wZW5pZCIsInByb2ZpbGUiLCJlbWFpbCJdLCJhdXRoX3RpbWUiOjE3MTM5MzY2OTcsInN1YiI6Ijg1MDA3MDgxOUBnZW5wYWN0LmNvbSIsIk9IUiI6Ijg1MDA3MDgxOSJ9.gO-Kq-js7t0AziROyA40vP36VQtgIE_FjBrW4TwneOid2m4icHPQbcj2nRnHxz68fBZoR8UuT3CLUJWJyFuc0tN1t39RRVsiysVR0sqOwD_9j347jywwu_lWkQr5fNRfTW3AZSsygQ8NF_bsCgnpvmLUyxXyWMLJtis1oURNNX9LL3zLtfXpbBQnB-x-As_NT1W0xrAEF2Ic7yhLWSt6xNqCu0dN3H6LFg56bK4znT4l0Z3FUkpCjAASgs4hei-imuo7z-C5z4jxZjCC_nrdoPwama7c15PpgB2J9e2ha5_iAwEFg5OExTqDIN--BxNXBOjtmHkMejCD7w4Nj0zyjg","claims":{"ver":1,"jti":"AT.sYPEbGOmd2WyxcusPqw9IycS6VwaOkVMAj0MHt-67-M","iss":"https://genpact.oktapreview.com/oauth2/default","aud":"api://default","iat":1713944218,"exp":1713947818,"cid":"0oa6akyxerb5CqQGc0x7","uid":"00u7ahhpe79z38kJx0x7","scp":["openid","profile","email"],"auth_time":1713936697,"sub":"850070819@genpact.com","OHR":"850070819"},"expiresAt":1713947819,"tokenType":"Bearer","scopes":["openid","profile","email"],"authorizeUrl":"https://genpact.oktapreview.com/oauth2/default/v1/authorize","userinfoUrl":"https://genpact.oktapreview.com/oauth2/default/v1/userinfo"}}
  // const tokenDataString = JSON.stringify(tokenData);
  // localStorage.setItem('okta-token-storage', tokenDataString);
  this.getOHR();
  this.document.body.classList.toggle('sidebar-collapse');
  const activeSubchildStored = localStorage.getItem('activeSubchild');
    if (activeSubchildStored) {
      this.activeSubchild = JSON.parse(activeSubchildStored);
    }
  this.isChecked = false;
  this.adminRoleViewList();
}
toggleActiveButton(){
    this.activeButtonActive = !this.activeButtonActive;
  //  this.common.expandValue(this.activeButtonActive)

}
getActiveButtonWidth() {
  return this.activeButtonActive ? 'showSideNav' : '';
}
changeRoute(item:any, hasChild:any, index?:any){
  this.menuSidebar.forEach((e:any)=>{
       e.isCollapsed =true
  });
}
toggleSubmenu(item: any, type:any): void {
  if (type == 'hasChild' ) {
    setTimeout(() => {
      this.menuSidebar.forEach((e:any)=>{
        if (e && e.link.includes(item.link)) {
           e.isCollapsed = !e.isCollapsed;
        }
      })
    }, 0);
  }
}
showSubmenu(item: any,hasChild?:any,index?:any): void {
  this.menuSidebar.forEach((e:any)=>{
    if (e.children && e.children.includes(item)) {
       e.isCollapsed = false;
    } else {
      e.isCollapsed = true;
    }

  })
}

handleRouteChange(url: string): void {
  this.menuSidebar.forEach((item:any) => {
    item.isCollapsed = true;
    if (item.children) {
       item.children.forEach((subItem:any) => {
        if(subItem['link'] === url){
          item.isCollapsed = false;
        }
      });
    }
  });
}
closeMenu(){
  this.activeButtonActive = false;
  this.getActiveButtonWidth();
}
shouldAnimate(item:any) {
  console.log("iten",item)
  return true
}

  toggelSlide(){
    this.document.body.classList.toggle('sidebar-collapse');

  }
 ngAfterViewInit(){
  this.formModal = new bootstrap.Modal(this.testModal.nativeElement,{} );
 }
 acceptTermsCondition(event: any){
  if (event.target.checked) {
    this.isChecked = true;
  } else {
    this.isChecked = false
  }
 }
 submit(){
  //  console.log(":SDfsdf")
  if(this.isChecked){
    // console.log("this",this.formModal)
    this.formModal?.hide();
    this.router.navigate(['document-summary']);
  }
}
logout(){
  this.pdfSummaryService.clearKnowledgeBaseApi().subscribe((val:any)=>{
    localStorage.removeItem('okta-token-storage');
    localStorage.removeItem('okta-username');
    localStorage.removeItem('token');
    localStorage.clear();
    sessionStorage.clear();
    this.oktaService.logout();
    this.router.navigate(['logout']);
console.log(val);
  },(error: any) => {
    console.error('An error occurred:', error);
  });
}

summary(){
  this.router.navigate(['document-summary']);
}
home(){
  this.router.navigate(['Home']);
}

selectType(type:any){
  this.viewType = type;
  console.log("selectType",this.viewType)
}

promptFileAction(val:any){
  this.showModal = false;
  if(val == 'upload'){
    this.showModal = true;
  } 
  if(val == 'download'){
     if(this.docType == '' || this.docType == null || this.docType?.currentValue == 'Select' || this.docType?.currentValue == ''){
      this.toastr.error('Please select a Document Type', 'Error!');
      this.showModal = false;
      this.dropdownType = "Select";

     } else {
      this.showModal = true;
      let param = ''

      if(this.docType?.currentValue == "Finance Functional" || this.docType == "Finance Functional"){
        param = "financeFunctional"
      } else {
        if(this.docType?.currentValue){
          param = this.docType?.currentValue
         } else {
           param = this.docType
         }
      }
      console.log(param)
      this.pdfSummaryService.getLogsFileList(param).subscribe((val:any)=>{
      this.logFileList  = val['Files'];
       },(error:any)=>{
     
       })
     }
   
  }
}
closeModal(){
  this.showModal = false;
  this.dropdownType = "Select"
}

handleFileInputLogs(event: Event) {
  const inputElement = event.target as HTMLInputElement;
  if (inputElement.files && inputElement.files.length === 1) {
      const file = inputElement.files[0];
      this.uploadFilesPrompt(file,event);
  } else {
    this.toastr.error('Please select a single file', 'Error!')
  }

}

uploadFilesPrompt(file: File,event:any) {
  if(this.docType == '' || this.docType == null || this.docType?.currentValue == 'Select' || this.docType?.currentValue == ''){
    this.toastr.error('Please select a Document Type', 'Error!');
    this.resetFileInput();
    this.showModal = false;
    this.dropdownType = "Select";
    return;
   }
  const formData = new FormData();
  let param = ''
  if(this.docType?.currentValue == "Finance Functional" || this.docType == "Finance Functional"){
    param = "financeFunctional"
  } else {
     if(this.docType?.currentValue){
       param = this.docType?.currentValue
      } else {
        param = this.docType
      }
  }
    formData.append('files', file);
    let fileData = event.target.files[0];
    let filename = fileData.name;

  this.pdfSummaryService.uploadFilePrompt(formData, param).subscribe((val:any)=>{
    if(val?.['status'] == 'Prompt File Uploaded' || val?.['status'] == 'Config File Uploaded'){
      this.resetFileInput();
      this.toastr.success(val?.status, 'Success!');
    } else {
      this.toastr.error('File format is not supported ', 'Error!');
      this.resetFileInput();
    }
  },(error:any) => {
   this.toastr.error(error?.error['message'], 'Error!');
   this.resetFileInput();

 })
}

downloadFile(fileName:any){
if (fileName.toLowerCase().includes('.properties')) {
  this.downloadWithExtension(fileName, 'properties');
} else if (fileName.toLowerCase().includes('.csv')) {
  this.downloadWithExtension(fileName, 'csv');
} else if (fileName.toLowerCase().includes('.log')) {
  this.downloadWithExtension(fileName, 'log');
} else {
  console.error('Unsupported file extension');
}

}

downloadWithExtension(fileName: string, fileExtension: string): void {
  let param = ''
  if(this.docType?.currentValue == "Finance Functional" || this.docType == "Finance Functional"){
    param = "financeFunctional"
  } else {
    if(this.docType?.currentValue){
      param = this.docType?.currentValue
     } else {
       param = this.docType
     }
  }
this.pdfSummaryService.downloadLogsFile(fileName,param).subscribe((data: Blob) => {
  const downloadLink = document.createElement('a');
  downloadLink.href = window.URL.createObjectURL(data);
  downloadLink.setAttribute('download', fileName); // Set the download attribute to the original filename
  document.body.appendChild(downloadLink);
  downloadLink.click();
  this.toastr.success("File downloaded successfully", "Success!")
});
}

getOHR() {
let userData = localStorage.getItem('okta-token-storage');
if (userData) {
  let ohr_id = JSON.parse(userData)?.accessToken?.claims?.OHR;
  return ohr_id ? ohr_id : null;
  }
 }
 resetFileInput() {
  this.fileInputPrompt.nativeElement.value = '';
  this.dropdownType = "Select";
  this.showModal = false;
 }

 adminRoleViewList(){
  this.pdfSummaryService.adminRoleView().subscribe((val:any)=>{
    if(val){
      this.viewTypeRole = val['role']
    }
  },(error: any) => {
    console.error('An error occurred:', error);
  })
}
}